<template>
    <ListPage
        :query="query"
        :total="total"
        v-loading="loading"
        :data="tableData"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @search="handleSearch"
        @reset="resetQuery"
    >
        <template slot="filters">
            <el-form-item label="" prop="search_keyword">
                <el-input v-model="query.search_keyword" placeholder="输入管理员名称进行检索" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('qxgl_glylb_xz')">
            <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="ID" align="center" prop="uuid" show-overflow-tooltip />
            <el-table-column label="管理员名称" align="center" prop="name" />
            <el-table-column label="角色" align="center" prop="mgroup.title" />
            <el-table-column label="账户" align="center" prop="account" />
            <el-table-column label="手机" align="center" prop="mobile" />
            <el-table-column label="最后登录时间" align="center" prop="login_time" />
            <el-table-column v-if="permission('qxgl_glylb_bj') || permission('qxgl_glylb_sc')" label="操作" align="center" width="100">
                <template slot-scope="{ row }">
                    <el-button v-if="permission('qxgl_glylb_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                    <el-button v-if="permission('qxgl_glylb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { list, del } from "@/api/auth/user";
import listMixin from "@/mixins/list";

export default {
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
            },
            module: "管理员",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleAdd() {
            this.$router.push({ path: "/auth/user/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/auth/user/form", query: { uuid: row.uuid } });
        },
    },
};
</script>
